/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { palDataHookStore } from '../useStore/useStore.js';

var palAccountDataGlobal;
if (typeof window !== 'undefined') {
  var handleAccountChange = function handleAccountChange(_ref) {
    var accountData = _ref.detail.accountData;
    palAccountDataGlobal = accountData;
    Object.keys(palDataHookStore).forEach(function (key) {
      var resetFunc = palDataHookStore[key].reset;
      if (resetFunc) resetFunc.call(palDataHookStore[key]);
    });
  };

  // Listen for updated account state (when a user changes the account in the common header)
  window.addEventListener('acctChanged', handleAccountChange);
}
var accountDataPromise = new Promise(function (resolve) {
  if (typeof window === 'undefined') {
    resolve({});
    return;
  }
  function whenAccountReady() {
    document.removeEventListener('DOMContentLoaded', whenAccountReady);
    if (window.header) {
      window.header.whenAccountReady(function (accountData) {
        resolve(accountData || {});
      });
    } else {
      resolve({});
    }
  }
  if (window.header && window.header.whenAccountReady) {
    whenAccountReady();
  } else {
    document.addEventListener('DOMContentLoaded', whenAccountReady);
  }
}).then(function (accountData) {
  palAccountDataGlobal = accountData;
  return accountData;
});
var isTest = typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test';
function getAccount() {
  if (palAccountDataGlobal) return Promise.resolve(palAccountDataGlobal);
  return accountDataPromise;
}
function getAccountIds() {
  // Make sure this function runs synchronously for unit test purposes
  if (isTest) {
    return {
      then: function then(cb) {
        return cb(['bssAccount', 'imsAccount', 'contextId']);
      }
    };
  }
  return getAccount().then(function (accountData) {
    var _accountData$account, _accountData$account2, _accountData$account3;
    return [accountData === null || accountData === void 0 || (_accountData$account = accountData.account) === null || _accountData$account === void 0 ? void 0 : _accountData$account.accountGuid, accountData === null || accountData === void 0 || (_accountData$account2 = accountData.account) === null || _accountData$account2 === void 0 ? void 0 : _accountData$account2.softlayerAccountId, accountData === null || accountData === void 0 || (_accountData$account3 = accountData.account) === null || _accountData$account3 === void 0 ? void 0 : _accountData$account3.contextId];
  });
}

export { getAccount, getAccountIds };
